import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const NoVehiclesWrapper = styled.section`
  width: 100%;
  padding: 32px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media ${device.mobileL} {
    padding: 32px 16px;
  }
  @media ${device.tablet} {
    padding: 32px 24px;
  }
  @media ${device.laptop} {
    padding: 32px 24px;
  }
  @media ${device.laptopL} {
    padding: 32px 64px;
  }
`;
export const NoVehiclesHeader = styled.h2`
  font-family: Audi Type Extended;
  font-size: 32px;
  line-height: 48px; /* 150% */
  letter-spacing: 0.003px;
  font-style: normal;
  font-weight: 400;
  text-align: center;
`;
export const NoVehiclesText = styled.div`
  padding-top: 24px;
  padding-bottom: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;
export const TextP = styled.p`
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
`;
export const CTAWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
export const Button = styled.button`
  background: inherit;
  width: 196px;
  height: 56px;
  border: 1px solid ${COLORS.black};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
`;
